const technicalSupportRequestId = 'dc6b3d28-a10c-ef11-9f89-000d3a1631b1';

export { technicalSupportRequestId };
